import { useMutation } from '@tanstack/react-query';
import { postAttachment } from '../../TimesheetsService';

const usePostAttachment = (options = {}) => useMutation(postAttachment, options);

export default usePostAttachment;
